module.exports = __webpack_public_path__ + "media/images/common/btn_adobe_acrobat_reader-642f051e85e70da79f567c56941740bf.png";